/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonQuickActionButtons from "../../../../components/_utils/CommonQuickActionButtons/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import InternalScheduleTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalScheduleTxnDeclinePopup.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import InternalAccountDetailsPopup from "../../../../components/Accounts/InternalAccount/InternalAccountDetailsPopup/index.jsx";
import OwnerAccountDetailsPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import { formatTimeSlot } from "../../../../components/ScheduleTransactions/helpers.js";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup/index.jsx";
import InternalTransactionGridView from "../../../../components/Transactions/InternalTransaction/InternalTransactionGridView/index.jsx";
import ScheduleInternalTransactionViewAllPopup from "../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionViewallpopup/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { internalTransactionsViewAll } from "../../../../redux/features/transactions/internalTransactions/index.js";
import {
  scheduledInternalApprove,
  scheduledInternalDetailsById,
  scheduledInternalDiscard,
  scheduledInternalOccurrences,
  setScheduledInternalDetails,
} from "../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  SettingsStatisticsConfiguration,
  TimelineBarConfiguration,
} from "../../../../utils/configurationProvider.js";
import formatCurrency from "../../../../utils/CurrencyFormater.js";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import TEXT from "../../../../utils/globalText.js";

const ScheduleInternalTransactionDetails = ({
  isPopup,
  txn_id,
  detailSelected,
  closeScheduleInternalTxnModal,
  typeMulti,
  type,
  flow,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const paramId = useParams().id;
  const id = txn_id ?? paramId;
  const services = useSelector((state) => state.refreshToken.services);
  const {
    scheduledInternalApproveLoading,
    scheduledInternalDetailsData,
    scheduledInternalDiscardLoading,
    scheduledInternalRejectError,
  } = useSelector((s) => s.scheduleInternalTransactions);

  const leftContentRef = useRef(null);

  const cardRefs = useRef({});
  const scrollContainerRef = useRef(null);

  const dropdownOptions = PaginationConfiguration?.paginationOptions;
  const hasModService = services?.includes("IAScheduledTxn");
  const hasOccurrenceService = services?.includes("IOScheduledTxn");

  const [scheduleUpdatedData, setScheduleUpdatedData] = useState(null);

  const [scheduleDetailsData, setScheduleDetailsData] = useState({});

  const [, setScheduleTnxListData] = useState();

  const [, setIsOpen] = useState(false);
  const [isloading, setIsLoading] = useState(true);

  const [scheduleId, setScheduleId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [showTLModal] = useState(false);
  const [doneBinding, setDoneBinding] = useState(false);

  const [transactionData, setTransactionData] = useState([]);

  const [btnClicked, setbtnClicked] = useState({});

  const [openTxnHistory, setOpenTxnHistory] = useState(false);

  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [openConfHistory, setOpenConfHistory] = useState(false);
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [scheduleDeleted, setScheduleDeleted] = useState(false);

  const [scheduleLifecycle, setScheduleLifecycle] = useState("");

  const [showRejectPrompt, setShowRejectPrompt] = useState(false);

  const [isScheduleRejected, setIsScheduleRejected] = useState(false);

  const [isScheduleApproved, setIsScheduleApproved] = useState(false);

  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);

  const [showOccurrencesModal, setShowOccurrencesModal] = useState(false);
  const [showInternalAccModal, setShowInternalAccModal] = useState(false);
  const [scheduleApproveFailed, setScheduleApproveFailed] = useState(false);
  const [scheduleOccurrenceDates, setScheduleOccurrenceDates] = useState([]);
  const [scheduleInternalTxnList, setScheduleInternalTxnList] = useState([]);

  const [isScheduleConfidential, setIsScheduleConfidential] = useState(false);

  const [scheduleInternalApproved, setScheduleInternalApproved] =
    useState(true);

  const [scheduleApproveFailedMessage, setScheduleApproveFailedMessage] =
    useState("");
  const [selectedDetail, setSelectedDetail] = useState(
    detailSelected === "Additional details" ? "Additional details" : "Details",
  );
  const [, setRightHeight] = useState("auto");

  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(scheduledInternalDetailsData?.[0]?.logs?.length || 0).fill(false),
  );
  const [ownerDetailpop, setOwnerDetailpop] = useState(false);
  const [internalAccDetailOpen, setInternalAccDetailOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(
    selectedDetail === "Details"
      ? GlobalConfiguration?.lengthCheckZero
      : selectedDetail === "Additional details"
        ? GlobalConfiguration?.lengthCheckOne
        : selectedDetail === "Transaction created"
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  const [, setIsSceduleApproveLoader] = useState(false);
  const [approvalStatus] = useState(false);

  const [, setLifecycleData] = useState([]);
  const [selectedImage, setSelectedImage] = useState({});
  const [openImageUrl, setOpenImageUrl] = useState(false);

  useEffect(() => {
    const updateHeight = () => {
      setRightHeight(leftContentRef?.current?.offsetHeight);
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [
    scheduledInternalDetailsData,
    scheduleLifecycle,
    isScheduleApproved,
    isScheduleRejected,
    scheduleDeleted,
  ]);

  const handleBeneAccModalClose = () => {
    setShowInternalAccModal(false);
    dispatch(
      scheduledInternalDetailsById({
        id,
      }),
    );
  };
  useEffect(() => {
    const updateHeight = () => {
      setRightHeight(leftContentRef?.current?.offsetHeight);
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  });
  useEffect(() => {
    if (!scheduledInternalDetailsData) return;

    setScheduleUpdatedData((prev) =>
      JSON.stringify(prev) === JSON.stringify(scheduledInternalDetailsData)
        ? prev
        : scheduledInternalDetailsData,
    );
  }, [scheduledInternalDetailsData]);

  const handleScheduleDiscard = async () => {
    try {
      UniversalRefreshToast("Discarding schedule");

      const result = await dispatch(
        scheduledInternalDiscard({
          id: scheduleId,
        }),
      );

      if (result?.payload?.status) {
        toast.dismiss();

        let data = structuredClone(result?.payload);
        data.transaction = result?.payload?.transactions;
        delete data?.transactions;

        dispatch(setScheduledInternalDetails(data));

        CommonToast({
          text: "Schedule discarded successfully.",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });

        setShowPromptModal(false);
      } else {
        setShowPromptModal(false);
      }
    } catch (errorMessage) {
      setShowPromptModal(false);
    }
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const openTransactionHistory = () => {
    setOpenTxnHistory(true);
  };

  const openConfidentialHistory = () => {
    setOpenConfHistory(true);
  };

  const formatDate = (value) => {
    let dateObj = new Date(value);

    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    let month = dateObj.toLocaleString("default", { month: "short" });
    let formattedDate = `${day} ${month}, ${year}`;

    if (formattedDate === null || formattedDate === undefined) {
      return "NA";
    } else {
      return formattedDate;
    }
  };

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${txn_id}`,
    });
  };

  // run function only when not popup (shows toast otherwise)
  const runIfNotPopup =
    (fn, warnMsg) =>
    (...args) => {
      if (isPopup) {
        actionRestricted();
        return;
      }
      if (typeof fn === "function") return fn(...args);
    };

  const safeSetShowPromptModal = () => {
    if (isPopup) {
      actionRestricted();
      return;
    }
    setShowPromptModal(true);
  };

  const removeDataFromStorage = () => {
    let storedData = JSON.parse(
      sessionStorage.getItem("intSelectedScheduleCard"),
    );

    if (storedData) {
      const updatedTransactions = storedData?.[0]?.selectedDetails.filter(
        (transaction) => transaction.txn_id !== scheduleId,
      );
      const updatedTransactionsId = storedData?.[0]?.selectedIds.filter(
        (transaction) => transaction !== scheduleId,
      );

      sessionStorage.setItem(
        "intSelectedScheduleCard",
        JSON.stringify([
          {
            selectedDetails: updatedTransactions,
            selectedIds: updatedTransactionsId,
          },
        ]),
      );
    }
  };

  const handleShowOccurrences = () => {
    (async () => {
      let response = await dispatch(
        scheduledInternalOccurrences({
          frequency: scheduleDetailsData?.frequency ?? "",
          transaction_start_date:
            scheduleDetailsData?.transaction_start_date || "Not available",
          transaction_end_date:
            scheduleDetailsData?.transaction_end_date || "Not available",
          services,
          navigate,
        }),
      );
      setScheduleOccurrenceDates(response?.payload?.dates ?? []);
      setShowOccurrencesModal(true);
    })();
  };

  const handleApprove = () => {
    (async () => {
      setbtnClicked((prev) => ({
        ...prev,
        [scheduleId]: "Approve",
      }));
      setIsSceduleApproveLoader(true);
      UniversalRefreshToast("Approving schedule");
      let response;
      if (type === "type bene_account_detail_modal") {
        response = await dispatch(
          scheduledInternalApprove({
            id: txn_id,
          }),
        );
      } else {
        response = await dispatch(
          scheduledInternalApprove({
            id: scheduleId,
          }),
        );
        if (response?.payload?.status ?? false) {
          if (typeMulti === "MultiApproval") {
            removeDataFromStorage();
          }
          setScheduleLifecycle("rejected");
          setShowRejectPrompt(false);
          // setTimeout(() => {
          //   CommonToast({
          //     text: "Schedule rejected successfully.",
          //     icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          //     variant: "var(--success)",
          //   });
          // }, IntervalConfiguration?.intervalLarge);
        } else {
          setbtnClicked((prev) => ({ ...prev, [scheduleId]: "none" }));
          setScheduleApproveFailed(true);
          setShowRejectPrompt(false);
          setScheduleApproveFailedMessage(
            response?.payload?.errors?.base?.[0]?.errors?.[0] ??
              "Something went wrong while rejecting transaction",
          );
          // setTimeout(() => {
          //   // toast.error(
          //   //   response?.payload?.errors?.base?.[0]?.errors?.[0],
          //   //   toast_position,
          //   // );
          //   CommonToast({
          //     text: response?.payload?.errors?.base?.[0]?.errors?.[0],
          //     icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          //     variant: "var(--error)",
          //   });
          // }, IntervalConfiguration?.intervalLarge);
        }
        dispatch(
          scheduledInternalDetailsById({
            id,
          }),
        );
      }

      setLifecycleData(scheduleUpdatedData?.transactions);

      if (response?.payload?.status) {
        toast.dismiss();
        let data = structuredClone(response?.payload);
        data.transaction = response?.payload?.transactions;
        delete data?.transactions;

        dispatch(setScheduledInternalDetails(data));

        setIsSceduleApproveLoader(false);
        if (typeMulti === "MultiApproval") {
          removeDataFromStorage();
        }

        setScheduleLifecycle("approved");

        setTimeout(() => {
          CommonToast({
            text: "Schedule approved successfully.",
            icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }, IntervalConfiguration?.intervalLarge);
      } else {
        setbtnClicked((prev) => ({ ...prev, [scheduleId]: "none" }));
        setScheduleApproveFailedMessage(
          response?.payload?.errors?.base?.[0]?.errors?.[0] ??
            "Something went wrong while approving transaction",
        );

        if (
          response?.payload?.errors?.base?.[0]?.errors?.[0] ===
            "Cannot approve. Transaction was auto-rejected as its start date or slot time has already passed." &&
          typeMulti === "MultiApproval"
        ) {
          removeDataFromStorage();
        }
        setScheduleApproveFailed(true);
        setTimeout(() => {
          CommonToast({
            text: response?.payload?.errors?.base?.[0]?.errors?.[0],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, IntervalConfiguration?.intervalLarge);
      }

      if (
        (typeMulti === "MultiApproval" ||
          typeMulti === "MultiApprovalSelect" ||
          flow === "Schedule_txn_detail_modal") &&
        isPopup
      ) {
        setTimeout(() => {
          closeScheduleInternalTxnModal();
          window.location.reload();
        }, 3000);
      }
    })();
  };
  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };
  const handleTimelinePopup = () => {
    if (isPopup) {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
    }
  };
  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };

  const renderDetailSection = () => {
    if (isloading) {
      return null;
    }
    if (
      scheduledInternalDetailsData?.transaction?.length ===
      GlobalConfiguration.lengthCheckZero
    ) {
      return (
        <div className="text-text-secondary text-font-sm p-padding-md">
          No transaction data available.
        </div>
      );
    }
    switch (tabIndex) {
      // case "Details":
      case GlobalConfiguration?.lengthCheckZero:
        return scheduledInternalDetailsData?.transaction?.map((account) => {
          const originItemList = [
            {
              heading: "Created by",
              content: `${account?.logs?.[0]?.first_name ?? ""} ${account?.logs?.[0]?.last_name ?? ""}`,
              type: "text",
            },
            {
              heading: "Created on",
              content: formatDateViewAll(account?.created_on, true, true),
              type: "text",
            },
          ];

          if (account?.created_via) {
            originItemList.push({
              heading: "Created via",
              content: account.created_via,
              type: "text",
            });
          }

          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div
                key={account.txn_id}
                className={`flex flex-col lg:flex-row my-margin-md mx-auto  lg:px-padding-base gap-gap-md max-w-screen-Qlg `}
              >
                <CommonDetailCard
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  cardTitle="Transfer Details"
                  entries={[
                    {
                      heading: "Frequency",
                      content:
                        scheduleDetailsData?.frequency
                          ?.charAt(0)
                          .toUpperCase() +
                          scheduleDetailsData?.frequency?.slice(1) ??
                        ""
                          ?.split("_")
                          .join(" ")
                          .replace(/\b\w/g, (c) => c.toUpperCase()),
                      type: "text",
                    },
                    {
                      heading: "Schedule start date",
                      content: formatDate(
                        scheduleDetailsData?.transaction_start_date ||
                          "Not available",
                      ),
                      type: "text",
                    },
                    {
                      heading: "Schedule end date",
                      content: formatDate(
                        scheduleDetailsData?.transaction_end_date ||
                          "Not available",
                      ),
                      type: "text",
                    },
                    {
                      heading: "Time slot",
                      content: formatTimeSlot(
                        scheduleDetailsData?.slot ?? " - ",
                      )
                        ?.replace(/\bAM\b/g, "am")
                        ?.replace(/\bPM\b/g, "pm"),
                      type: "text",
                    },
                    {
                      heading: "Occurrences",
                      content: Number(scheduleDetailsData?.occurrences || 0),
                      type: "text",
                      onClick: () => {
                        if (isPopup) {
                          actionRestricted();
                        } else if (hasOccurrenceService) {
                          handleShowOccurrences();
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "IOScheduledTxn",
                            },
                          });
                        }
                      },
                      isDisabled: isPopup || !hasOccurrenceService,
                    },
                  ]}
                />

                <CommonDetailCard
                  cardTitle={TEXT?.ORIGIN_DETAILS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={originItemList}
                />
              </div>
            </div>
          );
        });

      case GlobalConfiguration?.lengthCheckOne:
        // flatten all additional_data
        const allAdditionalData =
          scheduledInternalDetailsData?.transaction.flatMap(
            (txn) => txn.additional_data?.data ?? [],
          );

        const attachments = allAdditionalData.filter(
          (item) =>
            (item.data_type.toLowerCase() === "hyperlink" ||
              item.data_type === "File" ||
              item.data_type === "upload") &&
            "value" in item,
        );
        if (!allAdditionalData.length) {
          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div className="w-details-card-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md mt-margin-md">
                <div className="text-text-primary text-font-sm font-semibold">
                  {TEXT?.ADDITIONAL_DETAILS}
                </div>
                <p className="text-text-secondary text-font-xs font-normal">
                  Additional details are not supported for the selected
                  category.
                </p>
              </div>
            </div>
          );
        }

        return (
          <div
            key={tabIndex}
            className={animationClass}
          >
            <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md  lg:px-padding-base max-w-screen-Qlg mx-auto">
              <CommonDetailCard
                cardTitle={TEXT?.ADDITIONAL_DETAILS}
                variant="third"
                numCols={
                  allAdditionalData.length ===
                  TimelineBarConfiguration?.largewidth
                    ? TimelineBarConfiguration?.largewidth
                    : SettingsStatisticsConfiguration?.strokeWidthForLineGraph
                }
                entries={allAdditionalData
                  .map((item) => {
                    switch (item.data_type) {
                      case "from_year_to_year": {
                        const from = item.value?.from;
                        const to = item.value?.to;

                        return {
                          heading: item.name,
                          content: from && to ? `${from} - ${to}` : "Not given",
                          type: "text",
                        };
                      }

                      case "date_range": {
                        const start = item.value?.start_date;
                        const end = item.value?.end_date;

                        return {
                          heading: item.name,
                          content:
                            start && end ? `${start} - ${end}` : "Not given",
                          type: "text",
                        };
                      }

                      case "multi_select_list":
                        return {
                          heading: item.name,
                          content: item.value?.length
                            ? item.value.join(", ")
                            : "Not given",
                          type: "text",
                        };

                      case "toggle":
                        return {
                          heading: item.name,
                          content: item.value ? "Yes" : "No",
                          type: "text",
                        };

                      case "hyperlink":
                      case "upload":
                        return null;

                      default:
                        return {
                          heading: item.name,
                          content: item.value ?? "Not given",
                          type: "text",
                        };
                    }
                  })
                  .filter(Boolean)}
              />
              {attachments
                .map((obj) => {
                  const type = obj.data_type === "hyperlink" ? "link" : "file";

                  if (type === "link") {
                    if (!obj.value) return null;

                    return {
                      heading: "URL",
                      content: obj.value,
                      type: "link",
                    };
                  }

                  if (type === "file") {
                    const file = obj.value;
                    if (!file || !file.metadata || !file.file_url) return null;

                    return {
                      heading: "File",
                      type: "file",
                      content: {
                        size: file.metadata.size,
                        fileName: file.metadata.filename,
                        mimeType: file.metadata.mime_type,
                        url: file.file_url,
                      },
                    };
                  }

                  return null;
                })
                .filter(Boolean).length >
                GlobalConfiguration?.lengthCheckZero && (
                <CommonDetailCard
                  cardTitle={TEXT?.ATTACHMENTS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={attachments
                    .map((obj) => {
                      switch (obj.data_type) {
                        case "hyperlink": {
                          if (!obj.value) return null;

                          return {
                            heading: "URL",
                            content: obj.value || "Not given",
                            type: "link",
                          };
                        }

                        case "upload":
                        case "file": {
                          const file = obj.value;
                          if (!file || !file.metadata || !file.file_url)
                            return null;

                          const mimeType =
                            file?.metadata?.mime_type ||
                            "application/octet-stream";

                          if (mimeType.startsWith("image/")) {
                            return {
                              heading: "Image",
                              type: "image",
                              content: {
                                size: file.metadata.size,
                                fileName: file.metadata.filename,
                                mimeType: file.metadata.mime_type,
                                url: file.file_url,
                                onUrlClick: () => {
                                  setOpenImageUrl(true);
                                  setSelectedImage({
                                    name:
                                      file.metadata.filename || "Unknown file",
                                    url: file.file_url,
                                  });
                                },
                              },
                            };
                          }
                          return {
                            heading: "File",
                            type: "file",
                            content: {
                              size: file.metadata.size,
                              fileName: file.metadata.filename,
                              mimeType: file.metadata.mime_type,
                              url: file.file_url,
                              onUrlClick: () => {
                                window.open(file.file_url, "_blank")?.focus();
                              },
                            },
                          };
                        }

                        default:
                          return null;
                      }
                    })
                    .filter(Boolean)}
                />
              )}
            </div>
          </div>
        );

      case GlobalConfiguration?.lengthCheckTwo:
        return isloading ? (
          <div
            key={tabIndex}
            className={animationClass}
          >
            <div className="w-width-full flex justify-center items-center">
              <Loader />
            </div>
          </div>
        ) : (
          <div
            key={tabIndex}
            className={`${animationClass} flex flex-col Qmd:flex-row gap-y-gap-md gap-x-gap-sm flex-wrap  `}
          >
            <InternalTransactionGridView
              data={transactionData?.payload?.transactions}
              typepop="schedDetailViewAll"
              filterRef={scrollContainerRef}
            />
          </div>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    try {
      dispatch(disableSwitcher());
      (async () => {
        if (services) {
          dispatch(
            scheduledInternalDetailsById({
              id,
            }),
          );
        }
      })();
    } catch (error) {
      console.error(error);
    } finally {
    }

    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, [paramId]);

  useEffect(() => {
    setIsLoading(true);
    if (
      Array.isArray(scheduleUpdatedData?.transaction) &&
      scheduleUpdatedData.transaction?.length
    ) {
      setScheduleTnxListData();
      setScheduleDetailsData(scheduleUpdatedData?.transaction[0]);
      setScheduleInternalTxnList(
        scheduleUpdatedData?.transaction[0]?.internal_transaction_ids,
      );
      setLifecycleData(scheduleUpdatedData?.transaction);

      setIsScheduleApproved(
        scheduleDetailsData?.approved === "Y" ? true : false,
      );

      setIsScheduleRejected(
        scheduleDetailsData?.rejected === "Y" ? true : false,
      );

      // setScheduleDeleted((scheduleDetailsData?.deleted ?? "N") === "Y");
      setScheduleDeleted(scheduleDetailsData?.deleted === "Y" ? true : false);
      setScheduleLifecycle(scheduleDetailsData?.lifecycle_status ?? "pending");

      setIsScheduleConfidential(
        (scheduleDetailsData?.confidential_transaction ?? "N") === "Y",
      );
      if (scheduleDetailsData?.internal_account_approval_status === "pending") {
        setScheduleInternalApproved(false);
      }
      if (scheduleId !== id) {
        return;
      }

      // unused fields
      setScheduleId(scheduleId);
      if (scheduleUpdatedData) {
        setIsLoading(false);
      }
      setDoneBinding(true);
    }
  }, [scheduleUpdatedData]);

  useEffect(() => {
    const handleFetch = async () => {
      let data = await dispatch(
        internalTransactionsViewAll({
          page_item_count: pageSize,
          page_no: currentPage,
          txn_id: (scheduleDetailsData?.internal_transaction_ids ?? []) || [],
        }),
      );

      setTransactionData(data);
    };
    if (scheduleInternalTxnList?.length > GlobalConfiguration.lengthCheckZero) {
      handleFetch();
    }
  }, [scheduleInternalTxnList, currentPage, pageSize]);

  useEffect(() => {
    if (
      showOccurrencesModal ||
      showTLModal ||
      showPromptModal ||
      showRejectPrompt ||
      showInternalAccModal
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [
    showOccurrencesModal,
    showTLModal,
    showPromptModal,
    showRejectPrompt,
    showInternalAccModal,
  ]);
  useEffect(() => {
    const el = document.querySelector(".main_div");
    el?.scrollTo({ top: 100, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!scheduledInternalDetailsData) {
      setDoneBinding(true);

      return;
    }

    const lifecycle =
      scheduledInternalDetailsData?.transaction?.[0]?.lifecycle_status;

    const uiState = addLifeCycleStatus({
      lifecycle_status: lifecycle,
      services: services ?? [],
      cardType: "single",
    });

    setScheduleUpdatedData((prev) => {
      const prevLifecycle = prev?.transaction?.[0]?.lifecycle_status;
      const prevUiStatus = prev?.transaction?.[0]?.statusName;
      const newUiStatus = uiState?.statusName;

      if (
        prev &&
        prevLifecycle === lifecycle &&
        prevUiStatus === newUiStatus &&
        prev?.transaction?.length ===
          scheduledInternalDetailsData?.transaction?.length
      ) {
        return prev;
      }

      return {
        ...scheduledInternalDetailsData,
        transaction: scheduledInternalDetailsData?.transaction.map(
          (account) => ({
            ...account,
            loading: false,
            error: false,
            message: "",
            last_updated_user_id_check: false,
            ...uiState,
          }),
        ),
      };
    });

    if (scheduleUpdatedData) {
      setTimeout(() => {
        setIsLoading(false);
      }, IntervalConfiguration.intervalExtraLarge);
      // } else {
      // }
    }
    setScheduleId(scheduledInternalDetailsData?.transaction?.[0]?.txn_id);

    setDoneBinding(true);
  }, [scheduleUpdatedData]);

  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(tabIndex);
    }
  }, [tabIndex]);

  return !doneBinding ? (
    <>
      {!isPopup && (
        <>
          <div className=" fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-fixed-ui bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
            <div
              className="px-padding-md py-padding-sm flex flex-row items-center gap-gap-sm"
              onClick={() => {
                navigate(-1);
              }}
            >
              <div className=" mt-margin-xs pt-px">
                <SVGComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  color="var(--text-primary)"
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                />
              </div>

              <div className="flex flex-col justify-center items-start">
                <div className="text-font-md text-text-primary font-normal font-sans">
                  Internal schedule
                </div>
                <div className="text-font-xs text-text-secondary font-semibold font-sans">
                  Schedule detail
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-width-full h-full-height flex flex-row justify-center items-center">
        <Loader />
      </div>
    </>
  ) : (
    <>
      <>{RestrictedActionPopup}</>
      {showPromptModal && (
        <div className="fixed z-z-index-max flex  items-center justify-center  top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle="Confirm discarding this schedule?"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="No future transactions will be generated from this schedule."
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setShowPromptModal(false);
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Discard"
            btnTwoHandleFunction={handleScheduleDiscard}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            /* loader */
            btnTwoLoading={scheduledInternalDiscardLoading ?? false}
          />
        </div>
      )}
      {showOccurrencesModal && (
        <ScheduleTxnOccurrencesPopup
          closeCallback={() => setShowOccurrencesModal(false)}
          occurrences={scheduleOccurrenceDates}
        />
      )}
      {showRejectPrompt && (
        <InternalScheduleTxnDeclinePopup
          allTxnData={scheduleUpdatedData?.transaction}
          internalDetail={true}
          handleClose={() => {
            setShowRejectPrompt(false);

            setbtnClicked((prev) => ({
              [scheduleDetailsData.txn_id]: undefined,
            }));
          }}
          txnId={scheduleDetailsData?.txn_id ?? "N/A"}
          type="internalScheduleDetail"
          toastType="singleSchedule"
          flow={flow}
          removeDataFromStorage={removeDataFromStorage}
          typeMulti="MultiApprovalSelect"
          updateAllTxn={(updatedData) => {
            setScheduleUpdatedData((prev) => ({
              ...prev,
              transaction: updatedData,
            }));
          }}
        />
      )}
      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}
      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Schedule timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={scheduleUpdatedData?.transaction}
                handleApprovalClick={handleTimelinePopup}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"single"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {ownerDetailpop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-primary-black bg-opacity-dark-opacity">
          <OwnerAccountDetailsPopUp
            closeBeneAccountDetailModal={() => {
              setOwnerDetailpop(false);
            }}
            Remibursement_owneraccount_id={
              scheduleDetailsData?.owner_account_id ?? ""
            }
            type={"reimburseowner_details"}
          />
        </div>
      )}
      {/* duplicate InternalAccountDetailsPopup */}
      {internalAccDetailOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccountDetailsPopup
            internalAccDetailOpen={internalAccDetailOpen}
            closeBeneAccountDetailModal={() => setInternalAccDetailOpen(false)}
            bene_account_id={scheduleDetailsData?.internal_account_id ?? ""}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}
      {openTxnHistory && (
        <div className="fixed top-top-base left-left-base w-width-full h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          {openTxnHistory && (
            <div className="fixed top-top-base left-left-base w-width-full h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <ScheduleInternalTransactionViewAllPopup
                onClose={() => setOpenTxnHistory(false)}
                headerTitle="Schedule history"
                headerSubtitle="All scheduled transaction related to internal are listed below."
                popupProps={{ isscrollRequired: true }}
                contentProps={{
                  openTxnHistory,
                  onClose: () => {
                    setOpenTxnHistory(false);
                    setIsLoading(true);
                    setTimeout(() => {
                      setIsLoading(false);
                    }, IntervalConfiguration.intervalMedium);
                  },
                  txnHistorytype: "Schedule_Internal_Txn",
                  destination_account_number:
                    scheduleDetailsData?.internal_account_bank_acc_no ?? "",
                  source_account_number:
                    scheduleDetailsData?.owner_account_bank_acc_no ?? "",
                  owner_account_id: scheduleDetailsData?.owner_account_id ?? "",
                  internal_account_id:
                    scheduleDetailsData?.internal_account_id ?? "",
                }}
              />
            </div>
          )}
        </div>
      )}
      {transactionData?.payload?.transactions?.length > 0 &&
        selectedDetail === "Transaction created" && (
          <div className="fixed bottom-bottom-base w-width-full z-z-index-content">
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={transactionData?.payload}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
            />
          </div>
        )}
      {openConfHistory && (
        <div className="fixed top-top-base left-left-base w-width-full h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          {openConfHistory && (
            <div className="fixed top-top-base left-left-base w-width-full h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <ScheduleInternalTransactionViewAllPopup
                onClose={() => setOpenConfHistory(false)}
                headerTitle="Confidential transaction"
                headerSubtitle="All scheduled transaction related to internal are listed below."
                popupProps={{ isscrollRequired: true }}
                contentProps={{
                  txnHistorytype: "Schedule_Internal_Txn",
                  destination_account_number:
                    scheduleDetailsData?.internal_account_bank_acc_no ?? "",
                  source_account_number:
                    scheduleDetailsData?.owner_account_bank_acc_no ?? "",
                  owner_account_id: scheduleDetailsData?.owner_account_id ?? "",
                  internal_account_id:
                    scheduleDetailsData?.internal_account_id ?? "",
                  isConf: true,
                }}
              />
            </div>
          )}
        </div>
      )}
      {showInternalAccModal && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity"
          onClick={() => {
            handleBeneAccModalClose();
          }}
        >
          <InternalAccountDetailsPopup
            closeBeneAccountDetailModal={handleBeneAccModalClose}
            bene_account_id={scheduleDetailsData?.internal_account_id ?? ""}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}
      {!isPopup && (
        <>
          <div className=" fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-loader bg-primary-nav shadow-box-shadow-bottom Qsmd:hidden block">
            <TopNavComponent
              isFormattingNotRequired={true}
              topNavHeader={"Internal schedule"}
              topNavSubText="Schedule detail"
            />
          </div>
        </>
      )}
      {isloading ? (
        <div className="fixed inset-0 flex flex-1   items-center justify-center m-auto">
          <Loader />
        </div>
      ) : (
        <div
          className={`flex flex-col ${isPopup ? "h-full" : "h-screen"} overflow-hidden`}
        >
          <div
            className={`bg-primary-nav ${isPopup ? "hidden" : "h-mobile-create-header Qsmd:h-navbar-breadcrumb-height flex Qsmd:flex-shrink-0"}`}
          ></div>
          <div
            ref={scrollContainerRef}
            className={` scroll-py-top_md bg-primary-bg flex flex-col flex-1  overflow-x-hidden ${
              isPopup || openTxnHistory
                ? "overflow-y-hidden"
                : ` Qlg:overflow-y-auto ${
                    !isloading &&
                    tabIndex === GlobalConfiguration?.lengthCheckTwo &&
                    transactionData?.payload?.transactions?.length >
                      GlobalConfiguration?.lengthCheckZero
                      ? "mb-[--pagination-height]"
                      : ""
                  } `
            }`}
          >
            <div
              className={`bg-primary-bg ${isPopup ? "overflow-y-auto overflow-x-hidden" : ""}`}
            >
              <>
                <div className="hidden bg-primary-nav Qsmd:flex flex-row justify-center relative Qsmd:px-padding-md">
                  <div
                    className={`Qlg:max-w-tab-width-normal Qlg:w-std-width Qsmd:w-width-full relative ml-margin-md Qsmd:ml-margin-base`}
                  >
                    <div className="h-auto flex flex-row justify-center items-stretch">
                      <div className=" w-width-full flex flex-row justify-start items-center py-padding-md Qsmd:w-width-md">
                        <TitleSubtitlePair
                          title={scheduleDetailsData?.scheduled_name ?? "N/A"}
                          titleColor="text-primary"
                          subtitle={TEXT?.SCHEDULE_NAME}
                          info={false}
                          alignRight={false}
                          hoverOption="white"
                          isBold={false}
                          variant="md"
                        />
                      </div>

                      <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>
                      <div className="w-width-full flex flex-row justify-between items-center Qsmd:w-width-lg">
                        <div>
                          <TitleSubtitlePair
                            title={`INR ${formatCurrency(scheduleDetailsData?.amount ?? "")}`}
                            titleColor="settled"
                            subtitle="Amount"
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={true}
                            variant="md"
                          />
                        </div>
                        <div className="hidden Qsmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
                          <div className="Qsmd:flex flex-row overflow-hidden justify-end w-auto h-height-full">
                            {isScheduleConfidential ? (
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Confidential <br />
                                    transaction
                                  </>
                                }
                                btnType="button"
                                icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                                handleFunction={runIfNotPopup(
                                  openConfidentialHistory,
                                )}
                                isDisabled={isPopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                disabledTextColor="var(--text-primary)"
                                hoverOption="white"
                                fullWidthRequired={false}
                              />
                            ) : (
                              <div className="w-positive-negative-btn-width px-padding-xl ml-margin-lg py-padding-md box-border hidden" />
                            )}

                            {isScheduleConfidential && (
                              <div className="border-r border-solid border-primary-bg my-margin-sm" />
                            )}

                            <TopNavSmallButton
                              btnText={
                                <>
                                  Schedule <br /> history
                                </>
                              }
                              btnType="button"
                              icon={ICONS?.TRANSACTION_HISTORY}
                              handleFunction={runIfNotPopup(
                                openTransactionHistory,
                              )}
                              isDisabled={isPopup}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              disabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="border-primary-bg"></hr>
                    <div className="flex flex-row justify-center relative">
                      <div className="w-width-full flex flex-col items-center justify-around Qsmd:pt-padding-sm gap-gap-md Qsmd:w-width-md">
                        <div className="Qsmd:translate-x-[-0.5rem] flex flex-row items-center justify-between w-width-full Qsmd:pt-padding-sm">
                          <div
                            className={`${
                              isPopup || !services?.includes("VAccount")
                                ? " pl-padding-base "
                                : ""
                            }`}
                          >
                            <TitleSubtitlePair
                              isDisabled={
                                isPopup || !services?.includes("VAccount")
                                  ? true
                                  : false
                              }
                              alignRight={false}
                              title={formatAccountNumber(
                                scheduleDetailsData?.owner_account_bank_acc_no ??
                                  "",
                              )}
                              titleColor={"text-primary"}
                              subtitle={TEXT?.SOURCE_ACCOUNT}
                              onClick={() => {
                                if (isPopup) {
                                  actionRestricted();
                                  return;
                                }
                                if (!services?.includes("VAccount")) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VAccount",
                                    },
                                  });
                                  return;
                                } else {
                                  setOwnerDetailpop(true);
                                }
                              }}
                              info={false}
                              showArrow={true}
                              hoverOption={"white"}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                          <CommonBankLogo
                            ifsc={
                              scheduleDetailsData?.owner_account_ifsc_code ?? ""
                            }
                            variant="big"
                            type="pill"
                          />
                        </div>
                        <div className="flex flex-row justify-between items-center w-width-full h-positive-negative-btn-height Qlg:pt-padding-base pt-padding-sm Qsmd:px-padding-sm Qsmd:pl-padding-base">
                          <TitleSubtitlePair
                            isDisabled={false}
                            alignRight={false}
                            title={
                              scheduleDetailsData?.owner_account_ifsc_code ?? ""
                            }
                            titleColor={"text-primary"}
                            subtitle={TEXT?.IFSC_CODE}
                            info={false}
                            showArrow={false}
                            isBold={false}
                            variant={"md"}
                          />

                          <TitleSubtitlePair
                            textAlign="right"
                            alignRight={true}
                            title={
                              (scheduleDetailsData?.payment_method ?? "N/A") ||
                              "N/A"
                            }
                            subtitle={TEXT?.PAYMENT_METHOD}
                            variant="md"
                          />
                        </div>
                      </div>
                      <div className=" my-auto h-full flex flex-shrink-0 flex-col justify-center items-center">
                        <div className=" absolute border-l border-l-primary-bg h-height-vertical"></div>
                        <div className="arrow-icon bg-primary-nav px-padding-xs py-padding-sm relative">
                          <img
                            src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
                            alt="CircledWhiteArrow"
                            className="w-icon-md h-icon-md"
                          />
                        </div>
                      </div>

                      <div
                        className={`w-width-full flex flex-col Qsmd:w-width-lg ${!scheduleDeleted ? "items-start gap-y-gap-md" : "justify-around"}`}
                      >
                        <div className="flex flex-row items-center justify-between w-width-full gap-gap-md">
                          <div
                            className={`flex items-center justify-between mr-margin-md Qsmd:mr-margin-base w-full ${scheduleDeleted ? "Qsmd:pt-padding-base" : "Qsmd:pt-padding-sm"}`}
                          >
                            <div>
                              <TitleSubtitlePair
                                isDisabled={
                                  isPopup ||
                                  !(
                                    services?.includes("IVAccount") ||
                                    services?.includes("Admin")
                                  )
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  scheduleDetailsData?.internal_account_bank_acc_no ??
                                    "",
                                )}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => {
                                  if (isPopup) {
                                    actionRestricted();
                                  } else {
                                    if (
                                      services?.includes("IVAccount") ||
                                      services?.includes("Admin")
                                    ) {
                                      setInternalAccDetailOpen(true);
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService:
                                            "IVAccount, Admin",
                                        },
                                      });
                                    }
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>

                            <CommonBankLogo
                              ifsc={
                                scheduleDetailsData?.internal_account_ifsc_code ??
                                "Not available"
                              }
                              variant="big"
                              type="pill"
                            />
                          </div>

                          {!scheduleDeleted ? (
                            <div>
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Discard <br /> Schedule
                                  </>
                                }
                                btnType="button"
                                icon={ICONS?.DISCARD_WITH_WHITE_CIRCLE}
                                handleFunction={runIfNotPopup(() => {
                                  if (hasModService) {
                                    safeSetShowPromptModal();
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "IAScheduledTxn",
                                      },
                                    });
                                  }
                                })}
                                isDisabled={isPopup || !hasModService}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                disabledTextColor="var(--text-primary)"
                                hoverOption="white"
                              />
                            </div>
                          ) : (
                            <div className="min-w-[90px] min-h-[90px]"></div>
                          )}
                        </div>
                        <div
                          className={`flex flex-row gap-x-gap-md w-width-lg pl-padding-sm items-center ${!scheduleDeleted ? "justify-between" : "items-start pt-padding-sm"}`}
                        >
                          <TitleSubtitlePair
                            isDisabled={false}
                            alignRight={false}
                            title={
                              (scheduleDetailsData?.internal_account_ifsc_code ??
                                "") ||
                              "N/A"
                            }
                            titleColor={"text-primary"}
                            subtitle={TEXT?.IFSC_CODE}
                            info={false}
                            showArrow={false}
                            isBold={false}
                            variant={"md"}
                          />
                          <div className="w-topnav-small-btn-width h-positive-negative-btn-height"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col Qsmd:hidden w-width-full bg-primary-nav">
                  <div className="sched-name-mobile flex flex-col p-padding-md Qsmd:px-padding-md px-padding-md">
                    <TitleSubtitlePair
                      title={scheduleDetailsData?.scheduled_name ?? "N/A"}
                      titleColor="text-primary"
                      subtitle={TEXT?.SCHEDULE_NAME}
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qlg:mx-margin-base"></hr>
                  <div className="flex flex-col p-padding-md Qsmd:px-padding-md px-padding-md">
                    <TitleSubtitlePair
                      title={`INR ${formatCurrency(scheduleDetailsData?.amount ?? "N/A")}`}
                      titleColor="settled"
                      subtitle="Amount"
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={true}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qlg:mx-margin-base"></hr>
                  <div className="flex flex-col Qlg:pl-padding-sm py-padding-sm">
                    <div className="flex flex-row items-center justify-between ml-margin-base Qlg:ml-0 px-padding-sm   ">
                      <TitleSubtitlePair
                        isDisabled={
                          isPopup || !services?.includes("VAccount")
                            ? true
                            : false
                        }
                        alignRight={false}
                        title={formatAccountNumber(
                          scheduleDetailsData?.owner_account_bank_acc_no ?? "",
                        )}
                        titleColor={"text-primary"}
                        subtitle={TEXT?.SOURCE_ACCOUNT}
                        onClick={() => {
                          if (isPopup) {
                            actionRestricted();
                            return;
                          }
                          if (!services?.includes("VAccount")) {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "VAccount",
                              },
                            });
                            return;
                          } else {
                            setOwnerDetailpop(true);
                          }
                        }}
                        info={false}
                        showArrow={true}
                        hoverOption={"white"}
                        isBold={false}
                        variant={"md"}
                      />
                      <div className="bg-text-primary rounded-full mr-margin-md p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s">
                        <CommonBankLogo
                          ifsc={
                            scheduleDetailsData?.owner_account_ifsc_code ?? ""
                          }
                          variant="big"
                        />
                      </div>
                    </div>
                    <div className="flex flex-row gap-gap-md justify-around items-center Qlg:pr-padding-md mx-margin-md Qlg:mx-margin-base ">
                      <div className="border-b border-solid border-primary-bg w-width-full"></div>
                      <img
                        src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                        alt="arrowDownBlueWhite"
                        className="w-icon-md"
                      />
                      <div className="border-b border-solid border-primary-bg w-width-full"></div>
                    </div>
                    <div className="flex flex-row items-center justify-between Qlg:ml-margin-base px-padding-sm">
                      <TitleSubtitlePair
                        isDisabled={
                          isPopup ||
                          !(
                            services?.includes("IVAccount") ||
                            services?.includes("Admin")
                          )
                            ? true
                            : false
                        }
                        alignRight={false}
                        title={formatAccountNumber(
                          scheduleDetailsData?.internal_account_bank_acc_no ??
                            "",
                        )}
                        titleColor={"text-primary"}
                        subtitle={"Destination account"}
                        onClick={() => {
                          if (isPopup) {
                            actionRestricted();
                            return;
                          }
                          if (
                            services?.includes("IVAccount") ||
                            services?.includes("Admin")
                          ) {
                            setInternalAccDetailOpen(true);
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "IVAccount, Admin",
                              },
                            });
                          }
                        }}
                        info={false}
                        showArrow={true}
                        hoverOption={"white"}
                        isBold={false}
                        variant={"md"}
                      />
                      <div className="bg-text-primary rounded-full p-padding-sm mr-margin-md flex flex-row justify-center items-center px-padding-sm py-padding-button-s">
                        <CommonBankLogo
                          ifsc={
                            scheduleDetailsData?.internal_account_ifsc_code ??
                            ""
                          }
                          variant="big"
                        />
                      </div>
                    </div>
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qlg:mx-margin-base"></hr>
                  <div className="flex flex-col gap-gap-xs p-padding-md Qsmd:px-padding-md px-padding-md">
                    <TitleSubtitlePair
                      alignRight={false}
                      title={
                        (scheduleDetailsData?.payment_method ?? "N/A") || "N/A"
                      }
                      subtitle={TEXT?.PAYMENT_METHOD}
                      variant="md"
                    />
                  </div>
                </div>
              </>
              <div className="block Qsmd:hidden">
                {!(isScheduleApproved || scheduleDeleted) && (
                  <TimelineStatusBar
                    showMobile={true}
                    overrideAutoLoader
                    whichBtnClicked={btnClicked?.[scheduleId] || "none"}
                    isLoading={scheduledInternalApproveLoading}
                    failedToTakeaction={
                      scheduleApproveFailed || scheduledInternalRejectError
                    }
                    failedToTakeactionReason={
                      scheduleApproveFailedMessage ||
                      scheduledInternalRejectError?.errors?.base?.[0]
                        ?.errors?.[0] ||
                      scheduleUpdatedData?.message
                    }
                    accountApprovalPending={
                      !scheduleInternalApproved && !isScheduleRejected
                    }
                    accountApprovalPendingSubHeader={
                      services?.includes("IAScheduledTxn")
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() => {
                      if (services?.includes("IAAccount")) {
                        setShowInternalAccModal(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "IAAccount",
                          },
                        });
                      }
                    }}
                    isApprovalPendingDisabled={!services?.includes("IAAccount")}
                    rejected={isScheduleRejected}
                    rejectedReason={scheduleDetailsData?.rejection_reason}
                    pending={
                      !isScheduleApproved &&
                      !scheduleDeleted &&
                      !isScheduleRejected
                    }
                    rejectMobClick={() => {
                      if (hasModService) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [scheduleId]: "Reject",
                        }));
                        setShowRejectPrompt(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "IAScheduledTxn",
                          },
                        });
                      }
                    }}
                    isApproveMobDisable={!hasModService}
                    approveMobClick={() => {
                      if (hasModService) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [scheduleId]: "Approve",
                        }));
                        handleApprove();
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "IAScheduledTxn",
                          },
                        });
                      }
                    }}
                    isRejectMobDisable={!hasModService}
                    rejectBtnText={
                      <>
                        Reject <br /> Schedule
                      </>
                    }
                    approveBtnText={
                      <>
                        Approve <br /> Schedule
                      </>
                    }
                  />
                )}
              </div>
              <div className="flex flex-col justify-center bg-primary-bg">
                <div className="max-w-screen-Qlg lg:w-max-content-width w-width-full mx-auto mt-margin-md">
                  <div className="block Qsmd:hidden">
                    <CommonQuickActionButtons
                      title="Quick Actions"
                      actions={[
                        {
                          key: "schedule-history",
                          btnText: (
                            <>
                              Schedule
                              <br />
                              history
                            </>
                          ),
                          btnType: "button",
                          icon: ICONS?.TRANSACTION_HISTORY,
                          handleFunction: runIfNotPopup(openTransactionHistory),
                          isDisabled: isPopup,
                        },
                        {
                          key: "discard-schedule",
                          hidden: scheduleDeleted,
                          btnText: (
                            <>
                              Discard
                              <br />
                              Schedule
                            </>
                          ),
                          btnType: "button",
                          icon: ICONS?.DISCARD_WITH_WHITE_CIRCLE,
                          handleFunction: runIfNotPopup(() => {
                            if (hasModService) {
                              safeSetShowPromptModal();
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAScheduledTxn",
                                },
                              });
                            }
                          }),
                          isDisabled: isPopup || !hasModService,
                        },
                        {
                          key: "confidential-txn",
                          hidden: !isScheduleConfidential,
                          btnText: (
                            <>
                              Confidential
                              <br />
                              transaction
                            </>
                          ),
                          btnType: "button",
                          icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                          handleFunction: runIfNotPopup(
                            openConfidentialHistory,
                          ),
                          isDisabled: isPopup,
                        },
                      ]}
                    />
                  </div>
                  <>
                    <div
                      className={`Qlg:mx-margin-base ml-margin-md mr-margin-md mt-margin-md Qlg:mr-margin-base Qsmd:mx-margin-md flex flex-row  items-end  ${
                        !(
                          isScheduleApproved ||
                          isScheduleRejected ||
                          scheduleDeleted
                        )
                          ? ""
                          : "justify-start"
                      } `}
                    >
                      <div
                        className={`bg-primary-card rounded-t-border-radius-md  rounded-bl-border-radius-md  ${isScheduleApproved || scheduleDeleted ? "rounded-br-border-radius-md" : "rounded-br-border-radius-md Qsmd:rounded-br-none"} w-width-full Qsmd:w-width-sm Qlg:w-width-sm`}
                      >
                        <div
                          className={`bg-primary-nav relative rounded-border-radius-md w-width-full ${isPopup ? "cursor-not-allowed" : " "}`}
                        >
                          <div className="text-text-primary text-font-xs text-left font-semibold pt-padding-sm mb-margin-sm px-padding-md">
                            Schedule timeline
                          </div>
                          <hr className="relative left-left-base border-primary-bg border-t-border mx-margin-md"></hr>

                          <div ref={leftContentRef}>
                            <CommonTimeLineCard
                              logsData={scheduleUpdatedData.transaction}
                              approvalStatus={approvalStatus}
                              handleApprovalClick={handleTimelinePopup}
                              showApprovalTimeline={true}
                              showDistributionTimeline={false}
                              showDistributionRightIcon={true}
                              isDisabled={isPopup ? true : false}
                              showApprovalLeftIcon={true}
                              showApprovalDuration={true}
                              cardType={"single"}
                              leftCardTitle="Stage - Approval"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Web  */}
                      {!(isScheduleApproved || scheduleDeleted) && (
                        <TimelineStatusBar
                          showMobile={false}
                          overrideAutoLoader
                          whichBtnClicked={btnClicked?.[scheduleId] || "none"}
                          hasDistributionData={false}
                          // isLoading={schedulesInternalTxnApprovalLoading}
                          failedToTakeaction={
                            scheduleApproveFailed ||
                            scheduledInternalRejectError
                          }
                          failedToTakeactionReason={
                            scheduleApproveFailedMessage ||
                            scheduledInternalRejectError?.errors?.base?.[0]
                              ?.errors?.[0] ||
                            scheduleUpdatedData?.message
                          }
                          accountApprovalPending={
                            !scheduleInternalApproved && !isScheduleRejected
                          }
                          accountApprovalPendingSubHeader={
                            services?.includes("IAScheduledTxn")
                              ? "Account is not approved, approve account before approving transaction."
                              : "To approve the account, please contact the authorized person."
                          }
                          handleApprovalPendingBtn={() => {
                            if (services?.includes("IAAccount")) {
                              setShowInternalAccModal(true);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAAccount",
                                },
                              });
                            }
                          }}
                          isApprovalPendingDisabled={
                            !services?.includes("IAAccount")
                          }
                          rejected={isScheduleRejected}
                          rejectedReason={scheduleDetailsData?.rejection_reason}
                          pending={
                            !isScheduleApproved &&
                            !scheduleDeleted &&
                            !isScheduleRejected
                          }
                          rejectClick={() => {
                            if (hasModService) {
                              setbtnClicked((prev) => ({
                                ...prev,
                                [scheduleId]: "Reject",
                              }));
                              setShowRejectPrompt(true);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAScheduledTxn",
                                },
                              });
                            }
                          }}
                          isRejectDisable={!hasModService}
                          approveClick={() => {
                            if (hasModService) {
                              setbtnClicked((prev) => ({
                                ...prev,
                                [scheduleId]: "Approve",
                              }));
                              handleApprove();
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAScheduledTxn",
                                },
                              });
                            }
                          }}
                          isApproveDisable={!hasModService}
                          rejectBtnText={
                            <>
                              Reject <br /> Schedule
                            </>
                          }
                          approveBtnText={
                            <>
                              Approve <br /> Schedule
                            </>
                          }
                        />
                      )}
                    </div>
                  </>
                </div>
                <div
                  className={`bg-primary-bg Qlg:px-padding-md lg:px-padding-base mx-margin-md Qlg:mx-margin-base  ${scheduleDetailsData?.payload?.transactions?.length > GlobalConfiguration.lengthCheckZero ? "w-width-full" : ""}`}
                >
                  <>
                    <div className="mt-margin-md flex max-w-screen-Qlg mx-auto">
                      <div
                        className="flex gap-gap-sm bg-primary-card w-auto rounded-border-radius-md overflow-x-auto"
                        style={{ scrollbarWidth: "none" }}
                      >
                        <SwitcherTabs
                          initialActiveTab={
                            selectedDetail === "Additional details"
                              ? "Additional details"
                              : selectedDetail === "Transaction created"
                                ? "Transaction created"
                                : "Details"
                          }
                          tabs={[
                            {
                              label: "Details",
                              key: "Details",
                              handler: () => {
                                setSelectedDetail("Details");
                                setTabIndex(
                                  GlobalConfiguration?.lengthCheckZero,
                                );
                              },
                            },
                            {
                              label: "Additional details",
                              key: "Additional details",
                              handler: () => {
                                setSelectedDetail("Additional details");
                                setTabIndex(
                                  GlobalConfiguration?.lengthCheckOne,
                                );
                              },
                            },
                            ...(scheduleInternalTxnList?.length >
                            GlobalConfiguration?.lengthCheckZero
                              ? [
                                  {
                                    label: "Transaction created",
                                    key: "Transaction created",
                                    handler: () => {
                                      setSelectedDetail("Transaction created");
                                      setTabIndex(
                                        GlobalConfiguration?.lengthCheckTwo,
                                      );
                                    },
                                  },
                                ]
                              : []),
                          ]}
                          setTabIndex={setTabIndex}
                        />
                      </div>
                    </div>
                  </>
                  <div className="sched-detail-pane">
                    {renderDetailSection()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ScheduleInternalTransactionDetails;
